export const sisab = [
  {
    'eSF': {
      min: 2000,
      max: 3000,
    },
    'eAP-30h': {
      min: 1500,
      max: 2250,
    },
    'eAP-20h': {
      min: 1000,
      max: 1500,
    },
  },
  {
    'eSF': {
      min: 2500,
      max: 3750,
    },
    'eAP-30h': {
      min: 1875,
      max: 2813,
    },
    'eAP-20h': {
      min: 1250,
      max: 1875,
    },
  },
  {
    'eSF': {
      min: 2750,
      max: 4125,
    },
    'eAP-30h': {
      min: 2063,
      max: 3095,
    },
    'eAP-20h': {
      min: 1375,
      max: 2063,
    },
  },
  {
    'eSF': {
      min: 3000,
      max: 4500,
    },
    'eAP-30h': {
      min: 2250,
      max: 3375,
    },
    'eAP-20h': {
      min: 1500,
      max: 2250,
    },
  },
]
export const tableData = [
  {
    porte: '1 - Até 20 mil',
    eSF: { parametro: 2000, limite: 3000 },
    eAP30h: { parametro: 1500, limite: 2250 },
    eAP20h: { parametro: 1000, limite: 1500 },
  },
  {
    porte: '2 - Acima de 20 mil até 50 mil',
    eSF: { parametro: 2500, limite: 3750 },
    eAP30h: { parametro: 1875, limite: 2813 },
    eAP20h: { parametro: 1250, limite: 1875 },
  },
  {
    porte: '3 - Acima de 50 mil até 100 mil',
    eSF: { parametro: 2750, limite: 4125 },
    eAP30h: { parametro: 2063, limite: 3095 },
    eAP20h: { parametro: 1375, limite: 2063 },
  },
  {
    porte: '4 - Acima de 100 mil',
    eSF: { parametro: 3000, limite: 4500 },
    eAP30h: { parametro: 2250, limite: 3375 },
    eAP20h: { parametro: 1500, limite: 2250 },
  },
]
